import React from "react";
import { Modal, Button, Card } from "react-bootstrap";
import { Info } from "react-feather";

export default function ModalInformasi(props) {
  const { show, data, handleClose } = props;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
    >
      {/* HEADER */}
      <Modal.Header
        closeButton
        style={{
          background: "linear-gradient(135deg, #56ab2f, #a8e063)",
          color: "white",
          borderBottom: "none",
        }}
      >
        <Modal.Title
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Info size={20} />
          <strong>Informasi</strong>
        </Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body
        style={{
          background: "#f6fbf7",
          padding: "24px",
        }}
      >
        <Card
          style={{
            borderRadius: "16px",
            border: "none",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
          }}
        >
          <Card.Body style={{ padding: "20px" }}>
            <div
              style={{
                fontSize: "15px",
                lineHeight: "1.7",
                color: "#2f3e2f",
              }}
              dangerouslySetInnerHTML={{ __html: data?.isi }}
            />
          </Card.Body>
        </Card>

        {/* BUTTON */}
        <div
          className="d-flex justify-content-end"
          style={{ marginTop: "24px" }}
        >
          <Button
            onClick={handleClose}
            style={{
              background: "linear-gradient(135deg, #56ab2f, #a8e063)",
              border: "none",
              borderRadius: "10px",
              padding: "10px 24px",
              fontWeight: "600",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            TUTUP
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}